export default {
  ALL: "all",
  BANNER: "banner",
  NATIVE: "native",
  PUSH: "push",
};
